import { render, staticRenderFns } from "./TrendSelection.vue?vue&type=template&id=4d4f4e3c&name=trend-selection&"
import script from "./TrendSelection.vue?vue&type=script&lang=js&"
export * from "./TrendSelection.vue?vue&type=script&lang=js&"
import style0 from "./TrendSelection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports